import PageHeader from "@/components/common/page/PageHeader";
import Profile from "@/components/entities/app/profile/Profile";
import { AppRoutes } from "@/config/router";
import { faPencil } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const ProfileInfoPage = () => {
    const [t] = useTranslation();

    return (
        <div className="lg:px-5">
            <PageHeader title={t('pages.profile')} >
                <Link className="btn link" to={AppRoutes.EDIT_PROFILE}>
                    <FontAwesomeIcon icon={faPencil} />
                </Link>
            </PageHeader>
            <div>
                <Profile />
            </div>
        </div>
    )
}

export default ProfileInfoPage;